<template>
  <div class="card mb-4">
    <div class="card-header">
      <span class="loading-placeholder col-md-8"></span>
    </div>
    <div class="card-body">
      <div class="row mb-4">
        <div class="col-md-9">
          <span class="loading-placeholder col-md-12 mb-2"></span>
          <br>
          <span class="loading-placeholder thin col-md-9"></span>
          <br>
          <span class="loading-placeholder thin col-md-7"></span>
          <br>
          <span class="loading-placeholder thin col-md-8"></span>
          <br>
          <span class="loading-placeholder thin col-md-6"></span>
          <br>
          <span class="loading-placeholder thin col-md-10"></span>
        </div>
        <div class="col-md-3 d-flex flex-column align-items-end">
          <span class="loading-placeholder thick col-md-8 mb-2"></span>
          <br>
          <span class="loading-placeholder thick col-md-10 mb-1"></span>
          <br>
          <span class="loading-placeholder col-md-6 mb-1"></span>
          <br>
          <span class="loading-placeholder thin col-md-8"></span>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-9">
          <span class="loading-placeholder col-md-11 mb-2"></span>
          <br>
          <span class="loading-placeholder thin col-md-8"></span>
          <br>
          <span class="loading-placeholder thin col-md-6"></span>
          <br>
          <span class="loading-placeholder thin col-md-9"></span>
        </div>
        <div class="col-md-3 d-flex flex-column align-items-end">
          <span class="loading-placeholder thick col-md-8 mb-2"></span>
          <br>
          <span class="loading-placeholder thick col-md-9 mb-1"></span>
          <br>
          <span class="loading-placeholder col-md-5 mb-1"></span>
          <br>
          <span class="loading-placeholder thin col-md-7"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonReportGroup'
}
</script>

